import { createRoute } from 'atomic-router';

export const blocksRoute = createRoute();

export const requestSalaryRoute = createRoute<{ id: string }>();

export const processRoute = createRoute();

export const employeeRoute = createRoute<{ id: string }>();

export const teamRoute = createRoute<{ id: string }>();

export const sendReviewRoute = createRoute<{ id: string }>();

export const sendReviewMaterialsRoute = createRoute<{ id: string }>();

export const vacancyRoute = createRoute<{ id: number | undefined }>();

export const reviewProcessRoute = createRoute<{ id: string }>();

export const calendarRoute = createRoute();

export const tournamentTablePageRoute = createRoute();

export const toEmployeeFromTournamentTablePageRoute = createRoute<{
  id: number;
}>();

export const toTeamFromTournamentTablePageRoute = createRoute<{ id: number }>();

export const userTournamentResultsRoute = createRoute();

export const karmaCreateEventRoute = createRoute<{ id: string }>();

export const maintainRoute = createRoute();

export const productListRoute = createRoute();

export const productRoute = createRoute<{ slug: string }>();

export const routeFromTeamToEmployee = createRoute<{ id: number }>();

export const routeFromTeamToProduct = createRoute<{ id: number }>();

export const routeFromTeamToCreateEmployee = createRoute();

export const newVacancyFormRoute = createRoute();
export const editAboutTeamPageRoute = createRoute<{ id: string }>();

export const sendFeedbackRoute = createRoute<{ id: string }>();

export const updateEmployeeProfileRoute = createRoute<{ id: string }>();

export const routeFromEmployeeInfoToTeam = createRoute<{ id: number }>();

export const searchEmployeesPageRoute = createRoute();

export const mentoringRoute = createRoute();

export const routeFromVacanciesToNewVacancy = createRoute();

export const adaptationRoute = createRoute<{ id: string }>();

export const checkpointFeedbackRoute = createRoute<{ id: string }>();

export const newOccasionRoute = createRoute();

export const occasionRoute = createRoute<{ id: string }>();

export const editOccasionRoute = createRoute<{ id: string }>();
